class ProductHighlight {
  sections;
  currentSection = 0;
  currentSelectionTimeout;
  disableAutoCycle = false;
  displayTimeInMs = 10000;

  constructor(productHighlight) {
    this.productHighlight = productHighlight;
    this.sections = this.productHighlight.querySelectorAll("[highlight-section]");
    this.displayTimeInMs =
      parseInt(this.productHighlight.getAttribute("section-display-time-in-seconds")) * 1000;

    this.sections.forEach((section, index) => {
      section.addEventListener("click", () => {
        this.changeSection(index);
        this.disableAutoCycle = true;
      });
    });

    this.handleResize();
    window.addEventListener("resize", () => this.handleResize());

    let observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) =>
          this.handleViewportIntersection(entry.isIntersecting)
        );
      },
      { rootMargin: "0px", threshold: 0.2 }
    );

    let target = this.productHighlight.querySelector("#product-highlights");
    observer.observe(target);
  }

  cycleSection() {
    if (
      this.disableAutoCycle ||
      this.currentSection >= this.sections.length - 1
    )
      return;
    this.changeSection(this.currentSection + 1);
    this.currentSelectionTimeout = setTimeout(
      () => this.cycleSection(),
      this.displayTimeInMs
    );
  }

  changeSection(newSectionIndex) {
    if (this.currentSection === newSectionIndex) return;

    // Start hiding the current section right away
    if (this.currentSection !== -1) {
      this.hideSection(this.currentSection);
    }

    // Then show the new section
    this.showSection(newSectionIndex);
    this.currentSection = newSectionIndex;
    clearTimeout(this.currentSelectionTimeout);
  }

  showSection(index) {
    const desktopImage = this.productHighlight.querySelector(
      `[highlight-section-image="${index}"]`
    );
    desktopImage.classList.remove("hide-complete");

    const section = this.productHighlight.querySelector(`[highlight-section="${index}"]`);
    section
      .querySelectorAll(`[highlight-section-content]`)
      .forEach((content) => {
        // Ensure the element is visible to measure it
        content.style.display = "block";
				// Get the actual height
        let actualHeight = content.scrollHeight + "px";
				// Set max-height to actual height for transition
        content.style.maxHeight = actualHeight;
        content.style.opacity = "1";
      });
    section.classList.add("selected");
  }

  hideSection(index) {
    const desktopImage = this.productHighlight.querySelector(
      `[highlight-section-image="${index}"]`
    );
    desktopImage.classList.add("hide-inprogress");
    setTimeout(() => {
      desktopImage.classList.remove("hide-inprogress");
      desktopImage.classList.add("hide-complete");
    }, 900);

    const section = this.productHighlight.querySelector(`[highlight-section="${index}"]`);
    section
      .querySelectorAll(`[highlight-section-content]`)
      .forEach((content) => {
				// Collapse to zero height
        content.style.maxHeight = "0";
        content.style.opacity = "0";
      });
    section.classList.remove("selected");
    section.classList.add("shown");
  }

  handleResize() {
    const shouldBeMobileMode = this.isMobile(window.innerWidth);
    if (shouldBeMobileMode === this.mobileMode) return;
    this.mobileMode = shouldBeMobileMode;

    if (shouldBeMobileMode) {
      this.initMobileMode();
    } else {
      this.initDesktopMode();
    }
  }

  handleViewportIntersection(isVisible) {
    if (this.mobileMode || !isVisible) {
      clearTimeout(this.currentSelectionTimeout);
      return;
    }
    this.sections.forEach((section) => section.classList.remove("selected"));
    this.showSection(this.currentSection);
    this.currentSelectionTimeout = setTimeout(
      () => this.cycleSection(),
      this.displayTimeInMs
    );
  }

  isMobile(width) {
    return width < 992;
  }

  initMobileMode() {
    this.productHighlight
      .querySelectorAll("[highlight-section-content]")
      .forEach((content) => {
        content.style.maxHeight = "1000px";
        content.style.opacity = "1";
      });
    clearTimeout(this.currentSelectionTimeout);
  }

  initDesktopMode() {
    this.productHighlight
      .querySelectorAll("[highlight-section-content]")
      .forEach((content) => {
        content.style.maxHeight = "0";
        content.style.opacity = "0";
        content.style.transition = "max-height 0.9s ease-in-out, opacity 0.5s ease-in-out";
      });

    if (this.currentSection === -1) {
      this.changeSection(0);
    } else {
      const content = this.productHighlight.querySelector(
        `[highlight-section-content="${this.currentSection}"]`
      );
      content.style.maxHeight = "1000px";
      content.style.opacity = "1";
    }
  }
}

document.querySelectorAll('[data-product-highlight]').forEach(element => {
	new ProductHighlight(element);
});
